import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=65794033&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65794033",
  null
  
)

export default component.exports